import { combineReducers } from 'redux'
import { AppStore } from '.'

export async function combineReducersAsync<S extends AppStore, T extends {}>(...asyncReducers: (T | Promise<T>)[]) {
  const fullfilledReducers = await Promise.all(asyncReducers)
  return combineReducers<S>(Object.assign({}, ...fullfilledReducers))
}

export const storePanel = import('@panel/store').then(({ reducers }) => ({ reducers })).catch(() => ({ reducers: {} }))

export default [storePanel.then((store) => store.reducers)]
